const axios = require('axios');
const qs = require('qs');
import store from '../store';

//axios.defaults.baseURL = "https://localhost:50542/"
// Api Proxy
export function Get(url, request) {
    store.dispatch("shell/turnOnSpinner");
    return axios.get(url).then(res => {
        return store.dispatch("shell/handleResponse", res.data);
    }).catch(err => store.dispatch("shell/handleErrors", err));

}

export function Post(url, request) {
    store.dispatch("shell/turnOnSpinner");
    return axios.post(url, qs.stringify(request)).then(res => {
        return store.dispatch("shell/handleResponse", res.data);
    }).catch(err => store.dispatch("shell/addErrorMessages", err));
}

export function PostVoid(url, request) {
    axios.post(url, qs.stringify(request)).catch(err => store.dispatch("shell/addErrorMessages", err));
}

export function Redirect(intUrl, prodUrl) {
    var url = window.location.href;
    if (url.includes("localhost") || url.includes(".int.")) {
        window.location.assign(
            intUrl
        );
    } else {
        window.location.assign(
            prodUrl
        );
    }
}